import "./events.css";
import "../home/home.css";
import Masonry from "react-responsive-masonry";
import { public_gallery_img_list, public_gallery_video_list, public_videos_list } from "../public.api";

import { useState, memo, useCallback, useEffect } from "react";
import Loader from "../../../components/loader/loader";
import VideoTile from "../../../components/page/home/gallery/videotile";
import BreadCrumbsComp from "../../../components/navigator/breadcrumbs";
import SearchButton from "../../../components/buttons/search/search-btn";

const GalleryVideos = (props) => {
  let lang = props.state.language;
  const [data, setData] = useState([]);
  const [url, setUrl] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [searchDate, setSearchDate] = useState("");
  const [searchTitle, setSearchTitle] = useState("");

  const fetchEvents = () => {
    public_videos_list().then((res) => {
      setData(res.data);
      setUrl(res.current_url);
      setIsActive(false);
    });
  };

  useEffect(() => {
    fetchEvents();
  }, []);
  const settingColumns = useCallback(() => {
    if (window.innerWidth >= 1400) return 4;
    if (window.innerWidth >= 800) return 3;
    if (window.innerWidth >= 500) return 2;
    return 1;
  }, []);
  const [column, setColumn] = useState(() => settingColumns());
  let fromHome = sessionStorage.getItem("continueFrom");
  useEffect(() => {
    window.scrollTo(0, 0);
    window.addEventListener("resize", () => setColumn(() => settingColumns()));

    return window.removeEventListener("resize", () =>
      setColumn(() => settingColumns())
    );
  }, [setColumn, settingColumns]);

  const manageStatus = (e) => {
    const { name, value } = e.target;

    if (name === "searchTitle") {
      setSearchTitle(value);
    } else if (name === "searchDate") {
      setSearchDate(value);
    }
  };

  const handleSearch = () => {
    const searchParams = searchTitle || searchDate || ""; // Use either title, date, or an empty string

    public_gallery_video_list(searchParams).then((res) => {
      let filteredArray = res.data;
      console.log(filteredArray)
      // Filter by Title
      if (searchTitle) {
        filteredArray = filteredArray.filter((data) =>
          data[lang]?.Title.toLowerCase().includes(searchTitle.toLowerCase())
        );
        console.log(filteredArray)

      }

      // Filter by Date
      if (searchDate) {
        filteredArray = filteredArray.filter((data) => data[lang]?.date === searchDate);
      }

      setData(filteredArray);
      console.log(data)
    });
  };
  return (
    <div>
      {fromHome === "gallery" && <BreadCrumbsComp section="home" />}
      <Loader open={isActive} />
      <div>
        {/* ======================= Events  =================================================================== */}
        <div className="container-fluid event-bg">
          <div className="row m-55">
            {/* <h3>Gallery</h3> */}
            <h3>Videos </h3>
          </div>
        </div>

        <div className="row font-z m-4 justify-content-end">
          <div className="col-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search by Title"
              name="searchTitle"
              value={searchTitle}
              onChange={manageStatus}
            />
          </div>

          <div className="col-3">
            <input
              type="date"
              className="form-control"
              placeholder="Search by Date"
              name="searchDate"
              value={searchDate}
              onChange={manageStatus}
            />
          </div>


          <div className="col-2 d-flex">
            <SearchButton {...props} onClick={handleSearch} />
          </div>
        </div>


        <div className=" mtb-25">
          <div className="container gal-i">
            <div className="row">

              {/* <Masonry columnsCount={column} gutter="10px">
                {data &&
                  data?.map((item,index) => (
                    <>
                      <div className="items-center gap-4 w-full" >
                        <p className="galary_titles flex-1">{item[lang]?.Title}</p>
                        <video controls className="w-[200px] flex-shrink-0" key={item[lang]?.videos} >
                          <source src={item[lang]?.videos} type="video/mp4" />
                        </video>
                      </div>
                    </>
                  ))}
              </Masonry> */}
              {data && data.length > 0 ? (
                <Masonry columnsCount={column} gutter="10px">
                  {data.map((item, index) => (
                    <div className="border rounded shadow-sm p-3" >
                      <p className="galary_titles flex-1">{item[lang]?.Title}</p>
                      <video controls className="w-100" key={item[lang]?.videos} >
                        <source src={item[lang]?.videos} type="video/mp4" />
                      </video>
                    </div>
                  ))}
                </Masonry>
              ) : (
                <div className="no-data">
                <img src="resources/img/no1.png" alt="" />
                <h4>No Records Found..!!</h4>
              </div>

              )}

            </div>
          </div>
        </div>
        {/* =================================================================================================== */}
      </div>
    </div>
  );
};
export default memo(GalleryVideos);
